import {Button, DatePicker, Form} from "antd";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";
import {EyeSVGIcon} from "pages/Login/Login.config";
import {convertIosStringToDateDayjs} from "helper/common";
import moment from "moment";
const {INPUT} = FIELD_TYPE;

const validatePositiveInteger = (_, value) => {
  if (!value || /^[1-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};

const columnsTableMenu: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    render: (v, r, i) => i + 1,
    width: 20,
  },
  {
    title: "Trạng thái tư vấn",
    key: "tenTrangThai",
    dataIndex: "tenTrangThai",
    align: "left",
    width: 80,
  },
  {
    key: 4,
    title: "Thời gian tư vấn",
    dataIndex: "thoiGianTuVan",
    editable: true,
    type: "INPUT",
    width: 80,
    render: t => <div>{t ? moment(t).format(FORMAT_TIME.dateTime) : null}</div>,
    align:'center'
  },
  {
    key: 7,
    title: "Ghi chú",
    dataIndex: "ghiChu",
    editable: true,
    type: "AUTO_COMPLETE",
    width: 200,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    width: 30,
    fixed: "right",
  },
];

export {columnsTableMenu};
